import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditDisciplinaryCommittee = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        ground: '',
        decision_date: '',
        influence_measure: '',
        actions: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-disciplinary?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.ground) {
            newErrors.ground = 'Обязательное поле';
        }
        if (formInfo.ground && (formInfo.ground.length < 2 || formInfo.ground.length > 300)) {
            newErrors.ground = 'Значение не может быть меньше 2 и более 300 символов';
        }

        if (!formInfo.decision_date) {
            newErrors.decision_date = 'Обязательное поле';
        }

        if (!formInfo.influence_measure) {
            newErrors.influence_measure = 'Обязательное поле';
        }
        if (formInfo.influence_measure && (formInfo.influence_measure.length < 2 || formInfo.influence_measure.length > 300)) {
            newErrors.influence_measure = 'Значение не может быть меньше 2 и более 300 символов';
        }

        if (!formInfo.actions) {
            newErrors.actions = 'Обязательное поле';
        }
        if (formInfo.actions && (formInfo.actions.length < 2 || formInfo.actions.length > 300)) {
            newErrors.actions = 'Значение не может быть меньше 2 и более 300 символов';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const token = localStorage.getItem('token');

        axios.put('/api/add-new-disciplinary', {
            user_id: userId,
            ground: formInfo.ground,
            decision_date: normalizeDate(formInfo.decision_date),
            influence_measure: formInfo.influence_measure,
            actions: formInfo.actions,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-disciplinary`, {
            id: formInfo.id,
            user_id: userId,
            ground: formInfo.ground,
            decision_date: normalizeDate(formInfo.decision_date),
            influence_measure: formInfo.influence_measure,
            actions: formInfo.actions,
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений о дисциплинарной ответственности
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Основание</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.ground}  
                                    onChange={handleChange('ground')}
                                    className={errorsForm.ground ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{(formInfo.ground || '').length}/300</p>
                                {errorsForm.ground && <div className='errorUnderInput'>{errorsForm.ground}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата решения</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.decision_date?.split('T')[0]}
                                onChange={handleChange('decision_date')} 
                                className={errorsForm.decision_date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.decision_date && <div className='errorUnderInput'>{errorsForm.decision_date}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Мера воздействия</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.influence_measure}  
                                    onChange={handleChange('influence_measure')}
                                    className={errorsForm.influence_measure ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{(formInfo.influence_measure || '').length}/300</p>
                                {errorsForm.influence_measure && <div className='errorUnderInput'>{errorsForm.influence_measure}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Действия</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <textarea 
                                    cols='10' 
                                    rows='10' 
                                    value={formInfo.actions}  
                                    onChange={handleChange('actions')}
                                    className={errorsForm.actions ? 'inputError' : ''}
                                    minLength='' 
                                    maxLength='300' 
                                    require=''
                                >
                                </textarea>
                                <p className='description'>{(formInfo.actions || '').length}/300</p>
                                {errorsForm.actions && <div className='errorUnderInput'>{errorsForm.actions}</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditDisciplinaryCommittee;